import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import { useCallback, useRef, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import useE2EBypass from './useE2EBypass';
const BYPASS_TOKEN = 'BYPASS_TOKEN';

// The callbacks are memoised because /auth uses `resetRecaptcha` as an effect
// dependency: without this, that effect re-runs on every render unless React
// Compiler happens to memoise the returned object.
const useRecaptcha = () => {
  const $ = _c(8);
  const recaptchaRef = useRef(null);
  const [submittedToken, setSubmittedToken] = useState(null);
  const isE2EBypassActive = useE2EBypass();
  const isRecaptchaDisabled = isE2EBypassActive || !process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY;
  const recaptchaToken = isRecaptchaDisabled ? BYPASS_TOKEN : submittedToken;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = token => {
      setSubmittedToken(token);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const handleRecaptchaSubmission = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = token_0 => {
      handleRecaptchaSubmission(token_0);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleRecaptchaChange = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setSubmittedToken(null);
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleRecaptchaExpired = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      recaptchaRef.current?.reset();
      setSubmittedToken(null);
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const resetRecaptcha = t3;
  let t4;
  if ($[4] !== isE2EBypassActive || $[5] !== isRecaptchaDisabled || $[6] !== recaptchaToken) {
    t4 = {
      recaptchaRef,
      recaptchaToken,
      handleRecaptchaChange,
      handleRecaptchaExpired,
      resetRecaptcha,
      isE2EBypassActive,
      isRecaptchaDisabled
    };
    $[4] = isE2EBypassActive;
    $[5] = isRecaptchaDisabled;
    $[6] = recaptchaToken;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
export default useRecaptcha;